// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__SCCPC","bounce":"Logo_bounce__q55+l","logo_text":"Logo_logo_text__KEJyt"};